import { DAYS_OF_WEEK } from "@/constants/segmentOptions";

const DAY_LABEL = Object.fromEntries(
  DAYS_OF_WEEK.map((d) => [d.value, d.label]),
);

export const summarizeSchedule = (schedule) => {
  const rules = Array.isArray(schedule?.rules) ? schedule.rules : [];
  if (rules.length === 0) return null;
  const r = rules[0];
  const days = (Array.isArray(r.days) ? r.days : [])
    .map((d) => DAY_LABEL[d] ?? d)
    .join(", ");
  const label = `${days || "Any day"} ${r.start ?? "00:00"}–${r.end ?? "23:59"}`;
  return rules.length > 1 ? `${label} +${rules.length - 1}` : label;
};
